// sale-products-cashback-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Aceita cashback": "Acepta cashback",
    "Desligado, o cashback do cliente não desconta este produto no caixa": "Si está desactivado, el cashback del cliente no se descuenta de este producto en la caja",
};

export default catalogo;
